export default __webpack_public_path__ + "static/media/T14.84dea965.png";